import {
  IComparator,
  NameValue,
  SelectableEntity,
} from '@infodata-group/inf-commons';

export class Country extends SelectableEntity implements IComparator {
  public ceeMember: NameValue = new NameValue('', '');
  public code: string;
  public continent: NameValue = new NameValue('', '');
  public devise: string;
  public geoZone: NameValue = new NameValue('', '');
  public ibanLen: any;
  public label: string;
  public languages: string[];
  public phonePrefix: string;
  public postCodePrefix: string;
  public vatMask: string;

  constructor(code: string, label: string) {
    super(code, label, 'full');
    this.code = code;
  }

  getId(): string {
    return this.id;
  }

  getLabel(): string {
    return this.label;
  }

  toString(): string {
    return `${this.id} - ${this.label}`;
  }

  serialize(): any {
    return {};
  }

  convert(item: any): Country {
    const country = new Country(item.Code, item.Label);
    country.ceeMember.name = item.CeeMember?.Id;
    country.ceeMember.value = item.CeeMember?.Label;
    country.continent.name = item.Continent?.Id;
    country.continent.value = item.Continent?.Label;
    country.devise = item.Devise;
    country.geoZone.name = item.GeoZone?.Id;
    country.geoZone.value = item.GeoZone?.Label;
    country.ibanLen = item.IbenLen;
    // country.code = item.Code;
    // country.label = item.Label;
    country.languages = item.Languages;
    country.phonePrefix = item.PhonePrefix;
    country.postCodePrefix = item.PostCodePrefix;
    country.vatMask = item.TvaMask;
    return country;
  }

  compare(item: any): number {
    return this.code.localeCompare(item.code);
  }
}
